import { useState } from 'react';

import { Form } from 'antd';
import { useObserver } from 'mobx-react';

import { useStore } from '@store/index';

type IEletype = 'email' | 'phone';
type IParams = {
  /** 验证码验证时传的业务类型 12 提币 19 设置资金密码 默认 12 */
  type?: 12 | 19
}

export const useSafetyStore = () => {
  const { getSafetyStore } = useStore();
  return useObserver(() => getSafetyStore)
}

export const useUserBindInfo = () => {
  const { userStore: { userInfo: { isBindEmail, email, isBindGoogle, isBindPhone } } } = useStore();
  return useObserver(() => ({ isBindEmail, email, isBindGoogle, isBindPhone }))
}

export const useVerify = (params?: IParams) => {
  const { type = 12 } = params || {};
  const [form] = Form.useForm();
  const userBindInfo = useUserBindInfo();
  const safetyStore = useSafetyStore();
  const [isCountDown, setCountDown] = useState(false);
  const [isCountDownemail, setCountDownemail] = useState(false);

  /** 验证 */
  const onVerify = async (value): Promise<string> => {
    return safetyStore.getfull({
      ...value,
      type
    })
  }

  /** 重新发送 */
  const onResend = async (eletype: IEletype, params) => {
    const res = await safetyStore.sendVerifyCode(params);
    if (!res) return;
    eletype === 'email' ? setCountDownemail(true) : setCountDown(true);
  }
  return {
    form,
    userBindInfo,
    onVerify,
    onResend,
    isCountDown,
    isCountDownemail,
    setCountDown,
    setCountDownemail
  }
}
